import React,{useEffect, useState} from 'react';
import './Filter.css';
import {Stack,Box,TextField,Button,Grid} from '@mui/material';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { config } from '../App';
import axios from 'axios';
import Loading from './Loading';
import VideoCard from './VideoCard';
import Header from './Header';
import SearchIcon from "@mui/icons-material/Search";
import NotFound from './NotFound';

const Filter = ({videoPage})=>{
    const [allGenre,setAllGenre] = useState(true);
    const [education,setEducation] = useState(false);
    const [sports,setSports] = useState(false);
    const [comedy,setComedy] = useState(false);
    const [lifestyle,setLifeStyle] = useState(false); 
    const [contentRating,setContentRating] = useState();
    const [sortBy,setSortBy] = useState('releaseDate');
    const [videos,setVideos] = useState();
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(false);
    const [title,setTitle] = useState();
    let arr = [];
   

    useEffect(()=>{
        if(education && sports && comedy && lifestyle){
            setAllGenre(true);
            setEducation(false);
            setSports(false);
            setComedy(false);
            setLifeStyle(false);
        }
        if(!education && !sports && !comedy && !lifestyle){
            setAllGenre(true);
            arr=[]
        }
    },[education,sports,comedy,lifestyle])

    //  useEffect(async ()=>{
    //     let res = await axios.get(config.endpoint + '/v1/videos')
    //     console.log(res)
    // },[])

    useEffect(()=>{
        if(education) arr.push('Education')
        if(sports) arr.push('sports')
        if(comedy) arr.push('Comedy')
        if(lifestyle) arr.push('Lifestyle')
        
        let url = generateUrl();
        getVideos(url);
    },[contentRating,education,sports,comedy,lifestyle,sortBy,title])

    const generateUrl = ()=>{
        const params = {}

        if(title){
            params.title=title
        }

        if(arr.length > 0){
            params.genres = arr.join(',')
        }
        if(contentRating && contentRating!==''){
            params.contentRating = contentRating
        }
        if(sortBy!=='releaseDate') params.sortBy = sortBy;

        // console.log(new URLSearchParams(params).toString());
        return new URLSearchParams(params).toString();
    }


    const getVideos = async (url)=>{

        try {
            
            setLoading(true)
            setError(false);
            let res = await axios.get(`${config.endpoint}/v1/videos${url===''?'':'?'}${url}`)
            setLoading(false);
            setVideos(res.data.videos);
            // console.log(res);
        } catch (error) {
            setError(true);
            console.log(error);
        }
    }

    const handleSort = (e)=>{
        setSortBy(e.target.value);
    }

    const handleSearch = (e)=>{
        setTitle(e.target.value);
    }

    return(
        <>
        { !videoPage && <>
        <Header handleSearch={handleSearch}/>
        <Box sx={{background:'#202020'}}>
            <Stack alignItems='center' className='search-bar-mobile'>
                <Box className='search-container-mobile'>
                    <input placeholder="Search" className='search-input' onChange={handleSearch}></input>
                    <button className='search-button'><SearchIcon/></button>
                </Box>
            </Stack>
            <Box sx={{paddingTop:'21px'}}>
                
                <Stack direction='row' alignItems='center' gap='20px' justifyContent='center' sx={{ cursor: "pointer", flexWrap: "wrap" }}>
                    <Button className='genre-btn'
                    onClick={()=>{
                        setAllGenre(true)
                        setEducation(false)
                        setSports(false)
                        setComedy(false)
                        setLifeStyle(false)
                    }}
                    style={{
                        background : allGenre ? '#fff':'#202020' ,
                        color: allGenre ? '#202020':'#fff'
                    }}
                    >
                        All Genre
                    </Button>
                    <Button className='genre-btn'
                    onClick={()=>{
                        setEducation(!education)
                        setAllGenre(false);
                        
                    }}
                    style={{
                        background : education ? '#fff':'#202020' ,
                        color: education ? '#202020':'#fff'
                    }}
                    >
                        Education
                    </Button>
                    <Button className='genre-btn'
                     onClick={()=>{
                        setSports(!sports)
                        setAllGenre(false);
                    }}
                    style={{
                        background : sports ? '#fff':'#202020' ,
                        color: sports ? '#202020':'#fff'
                    }}
                    >
                        Sports
                    </Button>
                    <Button className='genre-btn'
                    onClick={()=>{
                        setComedy(!comedy)
                        setAllGenre(false);
                    }}
                    style={{
                        background : comedy ? '#fff':'#202020' ,
                        color: comedy ? '#202020':'#fff'
                    }}
                    >
                        Comedy
                    </Button>
                    <Button className='genre-btn'
                    onClick={()=>{
                        setLifeStyle(!lifestyle)
                        setAllGenre(false);
                    }}
                    style={{
                        background : lifestyle ? '#fff':'#202020' ,
                        color: lifestyle ? '#202020':'#fff'
                    }}
                    >
                        Lifestyle
                    </Button>

                    <Stack
                    className="category-form"
                    direction="row"
                    alignItems="center"
                    gap="10px"
                    >
                        <SwapVertIcon />
                        <select
                        className="sort-select"
                        value={sortBy}
                        onChange={handleSort}
                        
                        >
                            <option
                                style={{ height: "50px" }}
                                value='releaseDate'
                                id="release-date-option"
                            >
                                Release Date
                            </option>
                            <option id="view-count-option" value='viewCount'>
                                View Count
                            </option>
                        </select>
                  </Stack>
                </Stack>

            </Box>

            <Box sx={{ margin: "2rem 1rem 0" }}>
                <Stack direction='row' alignItems='center' gap='40px' justifyContent='center' sx={{ cursor: "pointer", flexWrap: "wrap" }}>
                    <Button className={'content-rating-btn'}
                    onClick={()=>{
                        setContentRating('')
                    }}
                    style={{
                        background : contentRating==='' ? '#fff':'#202020' ,
                        color:  contentRating==='' ? '#202020':'#fff'
                    }}
                    >
                        Any age group
                    </Button>
                    <Button className={'content-rating-btn'}
                    onClick={()=>{
                        setContentRating('7+')
                    }}
                    style={{
                        background : contentRating==='7+' ? '#fff':'#202020' ,
                        color:  contentRating==='7+' ? '#202020':'#fff'
                    }}
                    >
                        7+
                    </Button>
                    <Button className={'content-rating-btn'}
                    onClick={()=>{
                        setContentRating('12+')
                    }}
                    style={{
                        background : contentRating==='12+' ? '#fff':'#202020' ,
                        color:  contentRating==='12+' ? '#202020':'#fff'
                    }}
                    >
                        12+
                    </Button>
                    <Button className={'content-rating-btn'}
                    onClick={()=>{
                        setContentRating('16+')
                    }}
                    style={{
                        background : contentRating==='16+' ? '#fff':'#202020' ,
                        color:  contentRating==='16+' ? '#202020':'#fff'
                    }}
                    >
                        16+
                    </Button>
                    <Button className={'content-rating-btn'}
                    onClick={()=>{
                        setContentRating('18+')
                    }}
                    style={{
                        background : contentRating==='18+' ? '#fff':'#202020' ,
                        color:  contentRating==='18+' ? '#202020':'#fff'
                    }}
                    >
                        18+
                    </Button>


                </Stack>
            </Box>
           
        </Box>
        </>}
        {error && <NotFound/>}

        {loading ? <Loading/>:
            (
                <Box sx={{ padding: "3rem 5rem" }}>
                    <Grid container spacing={2}>
                        {videos?.map((video) => (
                            <Grid key={video._id} item xs={12} sm={6} md={3}>
                            <VideoCard video={video} sortBy={sortBy} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            )
        }
        </>
        
    )
}

export default Filter;